(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-result/assets/react/components/result.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-result/assets/react/components/result.js');

'use strict';

const _React = React,
  useEffect = _React.useEffect;
const _jotai = jotai,
  useAtomValue = _jotai.useAtomValue;
const _svs$lyckoplatsen$com = svs.lyckoplatsen.components.shared_result.jotai.atoms,
  selectedResultAtom = _svs$lyckoplatsen$com.selectedResultAtom,
  correctionStepAtom = _svs$lyckoplatsen$com.correctionStepAtom;
const productMapping = svs.lyckoplatsen.components.shared_constants.productMapping;
const _svs$lyckoplatsen$com2 = svs.lyckoplatsen.components.page_result.react.components,
  ResultStart = _svs$lyckoplatsen$com2.ResultStart,
  ButtonPlay = _svs$lyckoplatsen$com2.ButtonPlay;
const _svs$lyckoplatsen$com3 = svs.lyckoplatsen.components.shared_result.react.components,
  ProgressBarContainer = _svs$lyckoplatsen$com3.ProgressBarContainer,
  ResultDraw = _svs$lyckoplatsen$com3.ResultDraw,
  ResultDetails = _svs$lyckoplatsen$com3.ResultDetails;
const CharityPayout = svs.lyckoplatsen.components.shared_charity_payout.react.components.CharityPayout;
const WidgetArea = svs.components.tb_ui_react.widget_area.WidgetArea;
const Result = () => {
  const correctionStep = useAtomValue(correctionStepAtom);
  const selectedResult = useAtomValue(selectedResultAtom);
  useEffect(() => {
    if (correctionStep >= 1 && correctionStep <= 3) {
      svs.lyckoplatsen.utils.ui.hideFooter();
    }
    return () => {
      svs.lyckoplatsen.utils.ui.showFooter();
    };
  }, [correctionStep]);
  if (correctionStep === 0) {
    return React.createElement("div", {
      className: "lp-page-result"
    }, React.createElement(ResultStart, null));
  }
  return React.createElement("div", {
    className: "lp-result lp-grow"
  }, React.createElement(ProgressBarContainer, {
    isResult: true
  }), correctionStep >= 1 && correctionStep <= 3 && React.createElement(ResultDraw, null), correctionStep === 4 && React.createElement(React.Fragment, null, React.createElement(ResultDetails, {
    result: selectedResult,
    showBtnCenterSweden: true,
    showHomeLocationButton: true
  }), React.createElement(ButtonPlay, null), productMapping.isLyckoplatsenPrimary(selectedResult.productId) && React.createElement(CharityPayout, null), React.createElement(WidgetArea, {
    className: "lp-result-widget-area",
    areaName: "resultWidgetArea",
    widgetArea: "resultWidgetArea"
  })));
};
Object.assign(svs.lyckoplatsen.components.page_result.react.components, {
  Result
});

 })(window);